<!-- nav -->
<!-- <nav class="navbar navbar-expand navbar-dark bg-dark" *ngIf="utilizador">
  <div class="navbar-nav">
      <a class="nav-item nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
      <a class="nav-item nav-link" routerLink="/users" routerLinkActive="active">Users</a>
      <a class="nav-item nav-link" (click)="logout()">Logout</a>
  </div>
</nav> -->

<!-- main app container -->
<div class="app-container" [ngClass]="{ 'bg-light': user }">
  <router-outlet></router-outlet>
</div>

<!-- credits -->
<div class="text-center mt-4">
  <p>
      <mat-icon>copyright</mat-icon> 2020-2025 (and beyond <mat-icon>rocket</mat-icon>) Tripod
  </p>
  <p>
      <a href="https://tripod.pt" target="_top">tripod.pt</a>
  </p>
</div>
